import { User } from "@models/identity/user"

export class DeliveryNoteSettingsDto {
  id: number

  customerId: number
  
  fileNameFirstVariable: string
  fileNameSecondVariable: string
  fileNameThirdVariable: string

  numberOfDeliveryNotes: boolean
  isCreatedMonthly: boolean
}
